/**
 * The two routes an unauthenticated - or not-yet-activated - visitor is allowed
 * to sit on.
 *
 * These used to be tested three different ways in App.tsx: `!== '/setpassword'`
 * in the router gate, an unanchored `match(/(\/setpassword|\/login)/)` in the
 * redirect guard, and `startsWith('/setpassword')` in the activation guard. The
 * three disagreed on `/setpasswordfoo` and on any path merely containing
 * `/login`, which is how an exemption bug gets in. One predicate, matching
 * react-router's own segment semantics, so `/setpassword/x` counts and
 * `/setpasswordfoo` does not.
 */
const isRoute = (pathname: string, route: string): boolean => pathname === route || pathname.startsWith(`${route}/`);

export const SET_PASSWORD_ROUTE = '/setpassword';
export const LOGIN_ROUTE = '/login';
export const LOADING_ROUTE = '/loading';

export const isSetPasswordRoute = (pathname: string): boolean => isRoute(pathname, SET_PASSWORD_ROUTE);

export const isLoginRoute = (pathname: string): boolean => isRoute(pathname, LOGIN_ROUTE);

/**
 * The routes the app owns for its own navigation. Redirecting back to one of
 * these after login is how you build a loop, so `isValidRedirectPath` refuses
 * them.
 */
export const isSystemRoute = (pathname: string): boolean =>
	isLoginRoute(pathname) || isSetPasswordRoute(pathname) || isRoute(pathname, LOADING_ROUTE);
